'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _form = require('../form');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmStores = function (_Component) {
	_inherits(ConfirmStores, _Component);

	function ConfirmStores(props) {
		_classCallCheck(this, ConfirmStores);

		var _this = _possibleConstructorReturn(this, (ConfirmStores.__proto__ || Object.getPrototypeOf(ConfirmStores)).call(this, props));

		_this.state = {
			submitting: false,
			showErrors: false,
			stores: _this._transformStoresFromProps.bind(_this)(_this.props),
			regions: false,
			existingStores: false
		};

		_this.handleConfirm = _this._handleConfirm.bind(_this);
		_this.getRegions = _this._getRegions.bind(_this);
		_this.getStores = _this._getStores.bind(_this);
		_this.handleSetRegion = _this._handleSetRegion.bind(_this);
		_this.handleSetExistingStore = _this._handleSetExistingStore.bind(_this);
		_this.isValid = _this._isValid.bind(_this);
		return _this;
	}

	_createClass(ConfirmStores, [{
		key: '_transformStoresFromProps',
		value: function _transformStoresFromProps(props) {

			var storesFromProps = [].concat(_toConsumableArray(props.stores));
			storesFromProps.sort();
			var stores = [];
			for (var i = 0; i < storesFromProps.length; i++) {
				stores.push({
					name: storesFromProps[i],
					shouldImport: true,
					region: 8,
					existingStore: 0,
					action: 'merge'
				});
			}

			return stores;
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			// setTimeout(this.handleConfirm, 1000);
			this.getRegions();
			this.getStores();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.setState({
				stores: this._transformStoresFromProps.bind(this)(nextProps)
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    stores = _state.stores,
			    submitting = _state.submitting,
			    showErrors = _state.showErrors;


			var importCount = 0;

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("confirm-stores import-data-validation", { showErrors: this.state.showErrors }) },
				_react2.default.createElement(
					'div',
					{ className: 'title' },
					'Confirm New Stores'
				),
				_react2.default.createElement(
					'div',
					{ className: 'sub-title' },
					'Please select a region for each store and confirm that you wish to import it. New entries will be created for all stores selected in this list.'
				),
				_react2.default.createElement(
					'div',
					{ className: 'stores-list' },
					_react2.default.createElement(
						'div',
						{ className: 'store' },
						_react2.default.createElement(
							'div',
							{ className: 'name' },
							'Name'
						),
						_react2.default.createElement(
							'div',
							{ className: 'region' },
							'Region/Store'
						),
						_react2.default.createElement(
							'div',
							{ className: 'shouldCreate' },
							'Create/Merge'
						)
					),
					stores.map(function (store, i) {
						if (store.shouldImport) importCount++;
						return _react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)("store", store.action, { 'ignore': !store.shouldImport, 'import-store': !store.shouldImport, 'missing-region': !store.region }), key: i },
							_react2.default.createElement(
								'div',
								{ className: 'name' },
								store.name
							),
							_react2.default.createElement(
								'div',
								{ className: 'region' },
								_this2.renderDropdown.bind(_this2, store, i)()
							),
							_react2.default.createElement(
								'div',
								{ className: 'shouldCreate' },
								_react2.default.createElement('i', { className: 'fa fa-plus' }),
								_react2.default.createElement(_form.Toggle, {
									twoSided: true,
									active: store.action === "merge",
									onChange: _this2.handleToggleChange.bind(_this2, i)
								}),
								_react2.default.createElement('span', { className: 'merge', dangerouslySetInnerHTML: { __html: '<svg height="22" width="22" viewBox="0 0 640 1024" xmlns="http://www.w3.org/2000/svg"><path d="M512 192c-70.625 0-128 57.344-128 128 0 47.219 25.875 88.062 64 110.281V448c0 0 0 128-128 128-53.062 0-94.656 11.375-128 28.812V302.28099999999995c38.156-22.219 64-63.062 64-110.281 0-70.656-57.344-128-128-128S0 121.34400000000005 0 192c0 47.219 25.844 88.062 64 110.281V721.75C25.844 743.938 0 784.75 0 832c0 70.625 57.344 128 128 128s128-57.375 128-128c0-33.5-13.188-63.75-34.25-86.625C240.375 722.5 270.656 704 320 704c254 0 256-256 256-256v-17.719c38.125-22.219 64-63.062 64-110.281C640 249.34400000000005 582.625 192 512 192zM128 128c35.406 0 64 28.594 64 64s-28.594 64-64 64-64-28.594-64-64S92.594 128 128 128zM128 896c-35.406 0-64-28.625-64-64 0-35.312 28.594-64 64-64s64 28.688 64 64C192 867.375 163.406 896 128 896zM512 384c-35.375 0-64-28.594-64-64s28.625-64 64-64 64 28.594 64 64S547.375 384 512 384z"/></svg>' } })
							)
						);
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'btn btn-warning pull-right', onClick: this.props.reset },
					'Reset Import'
				),
				_react2.default.createElement(
					'div',
					{ className: 'btn btn-success', onClick: this.handleConfirm },
					submitting ? 'Submitting...' : 'Merge/Create ' + importCount + ' Stores'
				),
				_react2.default.createElement(
					'div',
					{ className: 'error' },
					showErrors ? 'Please select stores/regions for all stores!' : ''
				)
			);
		}
	}, {
		key: 'renderDropdown',
		value: function renderDropdown(store, i) {

			if (store.action === "create") {
				return _react2.default.createElement(_reactSelect2.default, {
					options: this.state.regions || [],
					isLoading: !this.state.regions,
					multi: false,
					value: store.region,
					onChange: this.handleSetRegion.bind(null, i),
					placeholder: 'Select Region'
				});
			}

			if (store.action === "merge") {
				return _react2.default.createElement(_reactSelect2.default, {
					options: this.state.existingStores || [],
					isLoading: !this.state.existingStores,
					multi: false,
					value: store.existingStore,
					onChange: this.handleSetExistingStore.bind(null, i),
					placeholder: 'Select Existing Store...'
				});
			}
		}
	}, {
		key: 'handleToggleChange',
		value: function handleToggleChange(i, e) {

			var stores = [].concat(_toConsumableArray(this.state.stores));
			stores[i].action = e.target.checked ? 'merge' : 'create';

			this.setState({
				stores: stores
			});
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.props.onCancel();
		}
	}, {
		key: '_handleConfirm',
		value: function _handleConfirm() {
			var _this3 = this;

			if (this.state.submitting) return;

			if (!this.isValid()) {

				this.setState({
					showErrors: true
				});

				return;
			}

			this.setState({
				submitting: true
			});

			_request2.default.post({
				url: location.origin + '/ajax/import/stores',
				form: {
					_token: CSRF_TOKEN,
					stores: this.state.stores
				}
			}, function (err, res, body) {
				if (err) {
					console.log(err);
				} else {
					_this3.props.onDone();
				}
			});
		}
	}, {
		key: '_getRegions',
		value: function _getRegions() {
			var _this4 = this;

			_request2.default.get({
				url: location.origin + '/ajax/regions'
			}, function (err, res, body) {
				if (err) {
					console.log(err);
				} else {
					_this4.setState({
						regions: JSON.parse(body)
					});
				}
			});
		}
	}, {
		key: '_getStores',
		value: function _getStores() {
			var _this5 = this;

			_request2.default.get({
				url: location.origin + '/ajax/stores'
			}, function (err, res, body) {
				if (err) {
					console.log(err);
				} else {
					_this5.setState({
						existingStores: JSON.parse(body)
					});
				}
			});
		}
	}, {
		key: '_handleSetRegion',
		value: function _handleSetRegion(i, newValue) {

			var stores = [].concat(_toConsumableArray(this.state.stores));
			stores[i] = _extends({}, stores[i], {
				region: newValue
			});

			this.setState({
				stores: stores
			});
		}
	}, {
		key: '_handleSetExistingStore',
		value: function _handleSetExistingStore(i, newValue) {

			var stores = [].concat(_toConsumableArray(this.state.stores));
			stores[i] = _extends({}, stores[i], {
				existingStore: newValue
			});

			this.setState({
				stores: stores
			});
		}
	}, {
		key: '_isValid',
		value: function _isValid() {
			var stores = this.state.stores;


			for (var i = 0; i < stores.length; i++) {
				if (stores[i].shouldImport && !stores[i].region) return false;
				if (stores[i].action === 'merge' && !stores[i].existingStore) return false;
			}

			return true;
		}
	}]);

	return ConfirmStores;
}(_react.Component);

exports.default = ConfirmStores;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/data/ConfirmStores.js
// module id = 564
// module chunks = 0